/**
 * Homepage / — migrated from public/js/home.js.
 *
 * 1. Input focus/blur .lb-focused
 * 2. Swiper carousels: blog-posts, testimonials, partners-map (Swiper 6 legacy)
 * 3. Domain search form — AJAX (legacy Form() la /request endpoint)
 */
import { Resort } from '../core/resort.js';
import { initWhenVisible } from '../shared/in-viewport.js';

declare const Swiper: new (selector: string, opts: unknown) => { init: () => void };

interface DomainItem { tld: string; price: string; status: number; order: string }
interface SearchResp { main: { fqdn: string; status: number; order: string }; suggest_list?: DomainItem[]; }

new Resort(() => {
    /* Input focus/blur — 2 selectors */
    ['input-wrapper', 'search-form'].forEach((cls) => {
        $(`.${cls} input[type="text"]`, true).on('focus', function (this: Element) {
            const p = this.parentElement;
            if (p && !p.classList.contains('lb-focused')) p.classList.add('lb-focused');
        });
        $(`.${cls} input[type="text"]`, true).on('blur', function (this: Element) {
            const p = this.parentElement;
            if (p?.classList.contains('lb-focused')) p.classList.remove('lb-focused');
        });
    });

    /* Swipers — PERF-5: defer below-the-fold init until near the viewport */
    initWhenVisible(document.querySelector('.blog-posts-container'), () => {
        new Swiper('.blog-posts-container', {
            slidesPerView: 2, speed: 800, spaceBetween: 10, grabCursor: true,
            pagination: { el: '.blog-posts .swiper-pagination', clickable: true },
            breakpoints: { 767: { slidesPerView: 1, spaceBetween: 10 } },
        });
    });

    initWhenVisible(document.querySelector('.testi-slider'), () => {
        new Swiper('.testi-slider', {
            slidesPerView: 4, speed: 800, spaceBetween: 18, grabCursor: true,
            navigation: { nextEl: '.testi-nav-bar .next', prevEl: '.testi-nav-bar .prev' },
            breakpoints: {
                767:  { slidesPerView: 1, spaceBetween: 18 },
                1023: { slidesPerView: 2, spaceBetween: 18 },
            },
        });
    });

    initWhenVisible(document.querySelector('.partners-map'), () => {
        const pSwipper = new Swiper('.partners-map', {
            slidesPerView: 2, speed: 800, init: false, spaceBetween: 18, grabCursor: true,
            breakpoints: { 767: { slidesPerView: 1, spaceBetween: 10 } },
            pagination: { el: '.partners .swiper-pagination', clickable: true },
        });
        if (window.innerWidth < 1200) pSwipper.init();
    });

    /* Domain search form */
    const searchForm = $('form.domain-search') as HTMLFormElement | null;
    const orderBox = $('.order-box') as HTMLElement | null;
    if (!searchForm) return;

    searchForm.Form('domains', 'get_info', {}, {
        return_true: (f: Record<string, unknown>) => {
            const wrapper = searchForm.find('.input-wrapper') as HTMLElement | null;
            if (!f['fqdn']) {
                if (wrapper) wrapper.style.borderColor = '#FFCC00';
                return false;
            }
            if (wrapper) wrapper.style.borderColor = 'rgba(255, 255, 255, 0.3)';
            return true;
        },
        done: (rs: unknown, data: unknown) => {
            if (rs !== 'Done' || !orderBox) return;
            const d = data as SearchResp;
            orderBox.classList.remove('hide');

            const mainStrong = orderBox.find('.main-domain strong') as HTMLElement | null;
            mainStrong?.text(d.main.fqdn);
            (orderBox.find('.main-domain span.not') as Element | null)?.classList.toggle('hide', d.main.status === 1);
            const mainBtn = orderBox.find('.main-btn-order') as HTMLAnchorElement | null;
            if (mainBtn) {
                mainBtn.style.display = d.main.status === 0 ? 'none' : 'inline-block';
                mainBtn.off('click');
                mainBtn.href = d.main.order;
            }

            (d.suggest_list ?? []).forEach((item) => {
                const col = orderBox.find(`.extensions .col[data-id="${item.tld}"]`) as Element | null;
                if (!col) return;
                (col.find('.ext-price') as HTMLElement | null)?.text(`€${item.price}`);
                const unavail = col.find('.ext-unavailable') as Element | null;
                const btn     = col.find('.btn-order') as HTMLAnchorElement | null;
                if (item.status === 1) {
                    unavail?.classList.add('hide');
                    if (btn) {
                        btn.style.display = 'inline-block';
                        btn.off('click');
                        btn.href = item.order;
                    }
                } else {
                    unavail?.classList.remove('hide');
                    if (btn) btn.style.display = 'none';
                }
            });
        },
    }, { loader: true });
});
